import { pxToRem } from "@deltek/specification-client/core/Utilities/unitUtils"
import { DialogTitle, makeStyles, Theme } from "@material-ui/core"
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    dialogTitle: {
        '& .MuiTypography-h6': {
            color: '#304959',
            fontSize: pxToRem(34),
        },
    },
}))

/**
 * Props for the ManageUnmappedDialogTitle component
 */
interface ManageUnmappedDialogTitleProps {
    /** The content to display in the dialog title */
    children: React.ReactNode
}

/**
 * Reusable dialog title component for manage unmapped product dialogs.
 * 
 * Provides consistent styling and accessibility attributes for dialog titles
 * across the manage unmapped product workflow.
 * 
 * @param props - The component props
 * @returns The ManageUnmappedDialogTitle component
 */
const ManageUnmappedDialogTitle = ({ children }: ManageUnmappedDialogTitleProps) => {
    const classes = useStyles()

    return (
        <DialogTitle
            id="manage-unmapped-dialog-title"
            className={classes.dialogTitle}
        >
            {children}
        </DialogTitle>
    )
}

export default ManageUnmappedDialogTitle